// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 🔥 1. IMPORTAMOS EL ENRUTADOR AQUÍ
import { BrowserRouter } from 'react-router-dom';

// --- TUS LÍNEAS PARA QUE FUNCIONEN LOS PDFS (NO BORRAR) ---
import { Buffer } from 'buffer';
window.Buffer = Buffer;
// ----------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* 🔥 2. ENVOLVEMOS LA APP CON EL BROWSERROUTER */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// 🔥 REGISTRO NATIVO DEL SERVICE WORKER EN REACT 🔥
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('Jarvis informa: Service Worker registrado al pelo en React:', registration.scope);
      })
      .catch((error) => {
        console.error('Jarvis informa: Falló el registro del Service Worker:', error);
      });
  });
}